import { Grid, Typography } from "@mui/material";
import { RequiredFieldLabel } from "components/FormControls/RequiredFieldLabel";
import { SelectInput } from "components/FormControls/Select/Select";
import { TextInput } from "components/FormControls/TextInput";
import { ExternalLink } from "ExternalLink";
import { useFormikContext } from "formik";
import { useMessage } from "hooks/intl";
import { OLPaper } from "OLPaper";
import { RewardFields } from "types/rewards";
import { alphabetizeByProperty } from "utilities/arrays";
import { useStyles } from "./RewardForm.styles";

export function CouponConfiguration() {
  const classes = useStyles();
  const { message } = useMessage();
  const { values } = useFormikContext<
    RewardFields & { areAutoGeneratedCouponCodes?: string }
  >();

  return (
    <OLPaper className={classes.OLPaper}>
      <SelectInput
        className={classes.fullWidth}
        items={[
          {
            id: "true",
            label: message({ id: "autogeneratedCoupons" }),
          },
          {
            id: "false",
            label: message({
              id: "couponsUploadedFromTheExternalSource",
            }),
          },
        ]}
        label={<RequiredFieldLabel text={message({ id: "sourceOfCoupons" })} />}
        name="areAutoGeneratedCouponCodes"
        data-test-id="reward-form-coupon-config-source-of-coupons-select-input"
      />
      {values.areAutoGeneratedCouponCodes === "false" ? (
        <Typography className={`${classes.inputInfo} ${classes.marginZero}`}>
          {message(
            { id: "importCouponsInfo" },
            {
              link: (
                <ExternalLink
                  className={classes.link}
                  path="https://help.openloyalty.io/rewards#adding-coupons"
                >
                  {message({
                    id: "learnMoreAboutCoupons",
                  })}
                </ExternalLink>
              ),
            },
          )}
        </Typography>
      ) : null}
      {values.areAutoGeneratedCouponCodes === "true" && (
        <Grid container spacing={12}>
          <Grid item xs={6}>
            <TextInput
              className={classes.fullWidth}
              label={
                <RequiredFieldLabel
                  text={message({
                    id: "couponLength",
                  })}
                />
              }
              name="couponGenerator.length"
              data-test-id="reward-form-coupon-config-coupon-length-input"
            />
          </Grid>
          <Grid item xs={6}>
            <SelectInput
              className={classes.fullWidth}
              items={alphabetizeByProperty(
                [
                  {
                    id: "alpha",
                    label: message({ id: "alpha" }),
                  },
                  {
                    id: "alphanum",
                    label: message({ id: "alphanum" }),
                  },
                  {
                    id: "num",
                    label: message({ id: "num" }),
                  },
                ],
                "label",
              )}
              label={
                <RequiredFieldLabel
                  text={message({
                    id: "couponCharset",
                  })}
                />
              }
              name="couponGenerator.characterSet"
              data-test-id="reward-form-coupon-config-coupon-charset-select-input"
            />
          </Grid>
          <Grid item xs={12}>
            <TextInput
              className={classes.fullWidth}
              label={message({
                id: "couponPrefix",
              })}
              name="couponGenerator.prefix"
              data-test-id="reward-form-coupon-config-coupon-prefix-input"
            />
          </Grid>
        </Grid>
      )}
    </OLPaper>
  );
}
